import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { formatCurrency } from '../../../util';

export const generateDashboardPDF = ({ revenueData, expenseData, summaryData, timePeriod, currencySymbol = '$' }) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;

    // Create a function to format currency with the correct symbol and a space
    const formatCurrencyWithSymbol = (amount) => {
        // Use the formatCurrency function but add a space between symbol and number
        if (currencySymbol) {
            return currencySymbol + ' ' + new Intl.NumberFormat('en-US', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(amount);
        }

        // If no symbol provided, use the default formatter
        return formatCurrency(amount, 'USD');
    };

    // Title
    doc.setFontSize(16);
    doc.text('Financial Summary Report', pageWidth / 2, 20, { align: 'center' });

    // Time period
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    const timePeriodText = typeof timePeriod === 'object' && timePeriod.startDate && timePeriod.endDate
        ? `Time period: ${timePeriod.startDate} to ${timePeriod.endDate}`
        : `Time period: ${timePeriod}`;
    doc.text(timePeriodText, 20, 30);

    // Revenue by Format Table
    doc.setFontSize(14);
    doc.text('Revenue by Format', 14, 45);

    doc.autoTable({
        startY: 50,
        head: [['Format', 'Quantity Sold', 'Revenue']],
        body: revenueData.map(item => [
            item.format,
            item.units_sold.toString(),
            formatCurrencyWithSymbol(item.total_amount)
        ]),
        styles: { fontSize: 10 },
        headStyles: { fillColor: [128, 128, 128] }
    });

    // Expenses by Category Table
    doc.text('Expenses by Category', 14, doc.lastAutoTable.finalY + 15);

    doc.autoTable({
        startY: doc.lastAutoTable.finalY + 20,
        head: [['Category', 'Amount']],
        body: expenseData.map(item => [
            item.category,
            formatCurrencyWithSymbol(item.total_amount)
        ]),
        styles: { fontSize: 10 },
        headStyles: { fillColor: [128, 128, 128] }
    });

    // Financial Summary Table
    doc.text('Financial Summary', 14, doc.lastAutoTable.finalY + 15);

    doc.autoTable({
        startY: doc.lastAutoTable.finalY + 20,
        body: [
            ['Gross Revenue', formatCurrencyWithSymbol(summaryData.grossRevenue), '100%'],
            ['Total Expenses', formatCurrencyWithSymbol(summaryData.totalExpenses), `${summaryData.expenseRatio.toFixed(1)}%`],
            ['Net Profit', formatCurrencyWithSymbol(summaryData.netProfit), `${summaryData.netProfitMargin.toFixed(1)}%`],
            ['Operating Margin', '', `${summaryData.operatingMargin.toFixed(1)}%`],
            ['Expense Ratio', '', `${summaryData.expenseRatio.toFixed(1)}%`],
        ],
        styles: { fontSize: 10 },
        theme: 'grid'
    });

    // Footer
    const today = new Date().toLocaleDateString();
    doc.setFontSize(10);
    doc.text(`Generated on ${today}`, pageWidth - 14, doc.internal.pageSize.height - 10, { align: 'right' });

    // Generate filename based on time period type
    const filename = typeof timePeriod === 'object' && timePeriod.startDate && timePeriod.endDate
        ? `financial_summary_${timePeriod.startDate}_to_${timePeriod.endDate}.pdf`
        : `financial_summary_${String(timePeriod).toLowerCase().replace(/\s/g, '_')}.pdf`;

    // Save the PDF
    doc.save(filename);
};
